import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';

import { ImageParentType } from '@image-upload/enums/image-parent-type.enum';
import {
  ProductActions,
  ProductSelectors,
} from '@products/store/products.slice';
import { ImagesTabForProductsComponent } from '@shared/components/images-tab-for-products/images-tab-for-products.component';

@Component({
  selector: 'app-product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.scss'],
})
export class ProductImagesComponent implements OnInit, OnDestroy {
  @ViewChild('imagesTabsComponent')
  imagesTabsComponent!: ImagesTabForProductsComponent;
  readonly type = ImageParentType.PRODUCT;
  packagingUnitId!: string;
  isSecondaryProduct$ = this.store.select(
    ProductSelectors.selectIsSecondaryProduct
  );

  subs = new Subscription();

  constructor(private readonly store: Store, readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.subs.add(
      combineLatest([
        this.store.select(ProductSelectors.selectEditedProductPackageUnitId),
        this.route.queryParams,
        this.route.parent!.data,
      ]).subscribe(([packagingUnitId, params, parentData]) => {
        if (!packagingUnitId) {
          this.store.dispatch(
            ProductActions.loadEditedProduct.trigger({
              packagingUnitId: params['id'],
              editable: !parentData['readOnly'],
            })
          );
        } else {
          this.packagingUnitId = packagingUnitId;
        }
      })
    );
  }

  canDeactivate() {
    return this.imagesTabsComponent.canDeactivate();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
